import * as types from './types';

export default {
  state: {
    errLog: [],
  },
  getters: {
    [types.ERR_LOG]: state => state.errLog,
  },
  mutations: {
    [types.ERR_LOG]: (state, payload) => {
      state.errLog = payload.errLog;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/school/school-detail/activity/index.js